// extracted by mini-css-extract-plugin
export default {"menu":"SideMenu_menu__wFIg9","logo-wrap":"SideMenu_logo-wrap__5bKzR"};